import React from 'react';
import { useDispatch } from 'react-redux';
import { Radio } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { setStatusAnalyzeFile } from '../../../store/slices/uploadAndAnalyzeAI';
import { OptimizeData } from '../../../types/optimizerTable';
import {
  OptionContainer,
  OptionInfoContactContainer,
  OptionCard,
  OptionCardContent,
  OptionCardContentInner,
  OptionInfo,
  OptionInfoTitle,
  OptionPrice,
  OptionInfoContact,
} from './RadioButtonsGroup.style';

function getDomain(url: string) {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}

interface RadioButtonsGroupProps {
  alternativeId: number;
  rowId: number;
  records: OptimizeData[];
  setRecordsData: (records: OptimizeData[]) => void;
}

const RadioButtonsGroup = ({ alternativeId, rowId, records, setRecordsData }: RadioButtonsGroupProps) => {
  const dispatch = useDispatch();
  const optCostsResults =
    records.find((item) => item.id === rowId)
      ?.optimizationOptions.find((option) => option.id === alternativeId)
      ?.optCostsResults || [];
  const handleClick = (selectedId: number) => {
    const updatedRecords = records.map((item) => {
      if (item.id === rowId) {
        return {
          ...item,
          optimizationOptions: item.optimizationOptions.map((option) => {
            if (option.id !== alternativeId) {
              return option;
            }
            if (option.optCostsResults) {
              return {
                ...option,
                optCostsResults: option.optCostsResults.map((result) => {
                  return {
                    ...result,
                    enabled: result.id === selectedId,
                  };
                }),
              };
            }
            return option;
          }),
        };
      }
      return item;
    });
    setRecordsData([...updatedRecords]);
    dispatch(setStatusAnalyzeFile({ status: 'success', records: [...updatedRecords] }));
  };
  return (
    <OptionContainer>
      {optCostsResults.map(({ id, title, contact, price, enabled }) => (
        <OptionCard key={id} enabled={enabled}>
          <OptionCardContent>
            <OptionCardContentInner>
              <Radio
                checked={enabled}
                onChange={() => handleClick(id)}
                value={id}
                name={`radio-buttons-${alternativeId}`}
                size="small"
              />
              <OptionInfo>
                <OptionInfoTitle>
                  {title}
                </OptionInfoTitle>
                <OptionInfoContactContainer>
                  <LinkIcon fontSize="small" color="action" />
                  <OptionInfoContact
                    variant="body1"
                    component="a"
                    href={contact}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {getDomain(contact)}
                  </OptionInfoContact>
                </OptionInfoContactContainer>
              </OptionInfo>
              <OptionPrice>
                {price}$
              </OptionPrice>
            </OptionCardContentInner>
          </OptionCardContent>
        </OptionCard>
      ))}
    </OptionContainer>
  );
};
export default RadioButtonsGroup;
